var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Timeline"},_vm._l((_vm.events),function(e,index){return _c('div',{staticClass:"box"},[(index!=0)?_c('process_line'):_vm._e(),_c('time_event',{attrs:{"event":e.event,"time":e.time,"color":_vm.color[index]}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }